jQuery(document).ready(function(){
// $(function(){
//   $('.bold_options_loaded').after('<div style="display:none;" class="sp-pro-button"><p type="button" class="js-open button-open under-button sp-button" style="position:relative;">テーブル脚の特徴</p><p type="button" class="js-open button-open under-button under-button-next sp-button" style="right: -25px;    top: 391px;">もっと見る</p></div>');

  
  
//   });

    
  
$(function () {
  $('.js-open-next').click(function () {
//     $('#overlay, .modal1').fadeIn();
    // window.open('https://kidomeimoku.co.jp/pages/tablelegs', '_blank');
  });

  $('.js-close').click(function () {
    $('#overlay, .modal1').fadeOut();
  });
});
  
  $(function () {
  $('.js-open-next-next').click(function () {
//     $('#overlay, .modal2').fadeIn();
        window.open('https://kidomeimoku.co.jp/pages/chairs', '_blank');
  });

  $('.js-close').click(function () {
    $('#overlay, .modal2, .sp-modal').fadeOut();
    $('.sp-modal').removeClass("modal-window");
  });
});
   $(function () {
  $('.contact-modal-open').click(function () {
    $('#overlay, .modal-window').fadeIn();
    $('body').addClass('kido-modal-open');
  });

  $('.js-close').click(function () {
    $('#overlay, .modal-window').fadeOut();
    $('body').removeClass('kido-modal-open');
  });

  // オーバーレイクリックでも閉じる
  $(document).on('click', '#overlay.overlay2', function() {
    $('#overlay, .modal-window').fadeOut();
    $('body').removeClass('kido-modal-open');
  });
});
  
   $(function () {
  $('.checkout-button2').click(function () {

    $('.checkout-button2').addClass("aaaa");
    $('#overlay, .modal-window').fadeIn();
  });

  $('.js-close').click(function () {
 $('#overlay, .modal-window').fadeOut();
  });
});
  

  
$(function () {
  $('.js-open').click(function () {
    $('#overlay, .modal-window').fadeIn();
  });

  $('.js-close').click(function () {
    $('#overlay, .modal-window').fadeOut();
  });
});
  
  $(function () {
  $('.sp-modal-show').click(function () {
    $('#overlay, .sp-modal , .button-close').fadeIn();
    $('.sp-modal').addClass("modal-window");
  });

  $('.sp-modal-close').click(function () {
    $('#overlay, .sp-modal').fadeOut();
  });
});
  
$(function () {
  $('.js-open-top').click(function () {
    $('#overlay, .modal-window').fadeIn();
  });

  $('.js-close-top').click(function () {
    $('#overlay, .modal-window').fadeOut();
  });
});

  
 $(function() {
   $(".bold_options_loaded").on("click", function() {

    // 対象外の要素の CSS をリセット
    $(".bold_options_loaded").parent().addClass("test");


  });
 });

function prod_detail_tabs_click(e) {
  const targetIsOpened = $('#' + $(e.target).attr('for')).prop('checked');
  
  if ( targetIsOpened ) {
    $(e.target).find('.bottomarrow').removeClass('rotated');

  } else {
    // 全てのタブを閉じて、ターゲットだけ開く
    $('#all-sec, #programming-sec, #design-sec, #henpin2, #all-third, #programming-third, #design-third').prop('checked', false);
    $('.one, .two, .three, .one-one, .two-two, .three-three').removeClass('rotated');

    $(e.target).find('.bottomarrow').addClass('rotated');
  }
}
  
$(function () {
  $('.first').click(prod_detail_tabs_click);
});
  
  $(function () {
  $('.second').click(prod_detail_tabs_click);

});
  
  $(function () {
  $('.third').click(prod_detail_tabs_click);

});
  
 $(function () {
  var size = $('.count').length;
  // 画面に表示
  $('.count-count').text(size);
});
  
 $(function(){
  $(".count-count-ko").each(function (i) {
   i = i+1;
   $(this).text(i);
  });
 });
  
  $(function () {
  $('.first-first').click(prod_detail_tabs_click);

});
  
  $(function () {
  $('.second-second').click(prod_detail_tabs_click);

});
  
   $(function () {
  $('.four').click(prod_detail_tabs_click);

});
  
  $(function () {
  $('.third-third').click(prod_detail_tabs_click);

});
  
  $(function () {
  $('.modal-image').click(function () {
    $(this). toggleClass("bigimg");
  });

});

  $(function(){
	var scrollPosition;
	$(".sp-modal-show").on("click", function() {
		scrollPosition = $(window).scrollTop();
		$('body').addClass('fixed').css({'top': -scrollPosition});
	});
	$(".js-close").on("click", function() {
		$('body').removeClass('fixed').css({'top': 0});
		window.scrollTo( 0 , scrollPosition );
	});
});
 

$(function(){
  $('.js-ranking-tab').on( 'click', function() {
    let id = $(this).data( 'ranking-id' );
    $('.js-ranking-tab').removeClass( 'active' );
    $('.js-ranking-list').removeClass( 'active' );
    $(this).addClass( 'active' );
    $('#ranking-'+id).addClass( 'active' );
  } );

});
  

  
 });


// // jQuery(document).ready
// (function(){
  

  
// $(function () {
//   $('.js-open-next').click(function () {
//     $('#overlay, .modal1').fadeIn();
//   });

//   $('.js-close').click(function () {
//     $('#overlay, .modal1').fadeOut();
//   });
// });
  
//   $(function () {
//   $('.js-open-next-next').click(function () {
//     $('#overlay, .modal2').fadeIn();
//   });

//   $('.js-close').click(function () {
//     $('#overlay, .modal2, .sp-modal').fadeOut();
//     $('.sp-modal').removeClass("modal-window");
//   });
// });


  
//   $(function () {
//   $('.sp-modal-show').click(function () {
//     $('#overlay, .sp-modal , .button-close').fadeIn();
//     $('.sp-modal').addClass("modal-window");
//   });

//   $('.sp-modal-close').click(function () {
//     $('#overlay, .sp-modal').fadeOut();
    
//   });
// });
  
// $(function () {
//   $('.js-open-top').click(function () {
//     $('#overlay, .modal-window').fadeIn();
//   });

//   $('.js-close-top').click(function () {
//     $('#overlay, .modal-window').fadeOut();
//   });
// });

  
//  $(function() {
//    $(".bold_options_loaded").on("click", function() {

//     // 対象外の要素の CSS をリセット
//     $(".bold_options_loaded").parent().addClass("test");


//   });
//  });
  

  
  
  
  
// $(function () {
//   $('.first').click(function () {
//     $('.one').toggleClass("rotated");
//   });

// });
  
//   $(function () {
//   $('.second').click(function () {
//     $('.two').toggleClass("rotated");
//   });

// });
  
//   $(function () {
//   $('.third').click(function () {
//     $('.three').toggleClass("rotated");
//   });

// });
  
//  $(function () {
//   var size = $('.count').length;
//   // 画面に表示
//   $('.count-count').text(size);
// });
  
//  $(function(){
//   $(".count-count-ko").each(function (i) {
//    i = i+1;
//    $(this).text(i);
//   });
//  });
  
//   $(function () {
//   $('.first-first').click(function () {
//     $('.one-one').toggleClass("rotated");
//   });

// });
  
//   $(function () {
//   $('.second-second').click(function () {
//     $('.two-two').toggleClass("rotated");
//   });

// });
  
//   $(function () {
//   $('.third-third').click(function () {
//     $('.three-three').toggleClass("rotated");
//   });

// });
  
//   $(function () {
//   $('.modal-image').click(function () {
//     $(this). toggleClass("bigimg");
//   });

// });

//   $(function(){
// 	var scrollPosition;
// 	$(".sp-modal-show").on("click", function() {
// 		scrollPosition = $(window).scrollTop();
// 		$('body').addClass('fixed').css({'top': -scrollPosition});
// 	});
// 	$(".js-close").on("click", function() {
// 		$('body').removeClass('fixed').css({'top': 0});
// // 		window.scrollTo( 0 , scrollPosition );
// 	});
// });
  

 

  

  


//  });



